import React, { useEffect, useState } from "react";
import CommonToast from "../../../../Common_Components/CommonToast";
import { getBlockNumberDataForCallingAgent, DeleteNumberFromBlockListForCallingAgent, AddNumberInBlockListForCallingAgent, DeleteNumberInBlockListbyIdForCallingAgent } from "../../../../../contexts/WorkspaceUtils";
import {
  Box,
  IconButton,
  Typography,
  Button,
  MenuItem,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  InputAdornment,
  Select,
  Input,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { button_bg_color_for_New_Project, settingsModal_bg_color_dm } from "../../../../../constants/colors";
import GetCountryFlagByName from "../../../settingBar/VideoGenSettings/GetCountryFlagByName";

const countryDatas = [
    { id: 1, name: "Afghanistan", code: "AF", mobileCode: "+93" },
    { id: 2, name: "Albania", code: "AL", mobileCode: "+355" },
    { id: 3, name: "Algeria", code: "DZ", mobileCode: "+213" },
    { id: 4, name: "Andorra", code: "AD", mobileCode: "+376" },
    { id: 5, name: "Angola", code: "AO", mobileCode: "+244" },
    // { id: 6, name: "Antigua and Barbuda", code: "AG", mobileCode: "+1-268" },
    { id: 7, name: "Argentina", code: "AR", mobileCode: "+54" },
    { id: 8, name: "Armenia", code: "AM", mobileCode: "+374" },
    { id: 9, name: "Australia", code: "AU", mobileCode: "+61" },
    { id: 10, name: "Austria", code: "AT", mobileCode: "+43" },
    { id: 11, name: "Azerbaijan", code: "AZ", mobileCode: "+994" },
    { id: 12, name: "Bahamas", code: "BS", mobileCode: "+1-242" },
    { id: 13, name: "Bahrain", code: "BH", mobileCode: "+973" },
    { id: 14, name: "Bangladesh", code: "BD", mobileCode: "+880" },
    { id: 15, name: "Barbados", code: "BB", mobileCode: "+1-246" },
    { id: 16, name: "Belarus", code: "BY", mobileCode: "+375" },
    { id: 17, name: "Belgium", code: "BE", mobileCode: "+32" },
    { id: 18, name: "Belize", code: "BZ", mobileCode: "+501" },
    { id: 19, name: "Benin", code: "BJ", mobileCode: "+229" },
    { id: 20, name: "Bhutan", code: "BT", mobileCode: "+975" },
    { id: 21, name: "Bolivia", code: "BO", mobileCode: "+591" },
    { id: 22, name: "Bosnia and Herzegovina", code: "BA", mobileCode: "+387" },
    { id: 23, name: "Botswana", code: "BW", mobileCode: "+267" },
    { id: 24, name: "Brazil", code: "BR", mobileCode: "+55" },
    { id: 25, name: "Brunei", code: "BN", mobileCode: "+673" },
    { id: 26, name: "Bulgaria", code: "BG", mobileCode: "+359" },
    { id: 27, name: "Burkina Faso", code: "BF", mobileCode: "+226" },
    { id: 28, name: "Burundi", code: "BI", mobileCode: "+257" },
    { id: 29, name: "Cabo Verde", code: "CV", mobileCode: "+238" },
    { id: 30, name: "Cambodia", code: "KH", mobileCode: "+855" },
    { id: 31, name: "Cameroon", code: "CM", mobileCode: "+237" },
    { id: 32, name: "Canada", code: "CA", mobileCode: "+1" },
    { id: 33, name: "Central African Republic", code: "CF", mobileCode: "+236" },
    { id: 34, name: "Chad", code: "TD", mobileCode: "+235" },
    { id: 35, name: "Chile", code: "CL", mobileCode: "+56" },
    { id: 36, name: "China", code: "CN", mobileCode: "+86" },
    { id: 37, name: "Colombia", code: "CO", mobileCode: "+57" },
    { id: 38, name: "Comoros", code: "KM", mobileCode: "+269" },
    { id: 39, name: "Congo (Congo-Brazzaville)", code: "CG", mobileCode: "+242" },
    { id: 40, name: "Congo (Congo-Kinshasa)", code: "CD", mobileCode: "+243" },
    { id: 41, name: "Costa Rica", code: "CR", mobileCode: "+506" },
    { id: 42, name: "Croatia", code: "HR", mobileCode: "+385" },
    { id: 43, name: "Cuba", code: "CU", mobileCode: "+53" },
    { id: 44, name: "Cyprus", code: "CY", mobileCode: "+357" },
    { id: 45, name: "Czech Republic", code: "CZ", mobileCode: "+420" },
    { id: 46, name: "Denmark", code: "DK", mobileCode: "+45" },
    { id: 47, name: "Djibouti", code: "DJ", mobileCode: "+253" },
    { id: 48, name: "Dominica", code: "DM", mobileCode: "+1-767" },
    { id: 49, name: "Dominican Republic", code: "DO", mobileCode: "+1-809" },
    { id: 50, name: "Ecuador", code: "EC", mobileCode: "+593" },
    { id: 51, name: "Egypt", code: "EG", mobileCode: "+20" },
    { id: 52, name: "El Salvador", code: "SV", mobileCode: "+503" },
    { id: 53, name: "Equatorial Guinea", code: "GQ", mobileCode: "+240" },
    { id: 54, name: "Eritrea", code: "ER", mobileCode: "+291" },
    { id: 55, name: "Estonia", code: "EE", mobileCode: "+372" },
    { id: 56, name: "Eswatini (Swaziland)", code: "SZ", mobileCode: "+268" },
    { id: 57, name: "Ethiopia", code: "ET", mobileCode: "+251" },
    { id: 58, name: "Fiji", code: "FJ", mobileCode: "+679" },
    { id: 59, name: "Finland", code: "FI", mobileCode: "+358" },
    { id: 60, name: "France", code: "FR", mobileCode: "+33" },
    { id: 61, name: "Gabon", code: "GA", mobileCode: "+241" },
    { id: 62, name: "Gambia", code: "GM", mobileCode: "+220" },
    { id: 63, name: "Georgia", code: "GE", mobileCode: "+995" },
    { id: 64, name: "Germany", code: "DE", mobileCode: "+49" },
    { id: 65, name: "Ghana", code: "GH", mobileCode: "+233" },
    { id: 66, name: "Greece", code: "GR", mobileCode: "+30" },
    { id: 67, name: "Grenada", code: "GD", mobileCode: "+1-473" },
    { id: 68, name: "Guatemala", code: "GT", mobileCode: "+502" },
    { id: 69, name: "Guinea", code: "GN", mobileCode: "+224" },
    { id: 70, name: "Guinea-Bissau", code: "GW", mobileCode: "+245" },
    { id: 71, name: "Guyana", code: "GY", mobileCode: "+592" },
    { id: 72, name: "Haiti", code: "HT", mobileCode: "+509" },
    { id: 73, name: "Honduras", code: "HN", mobileCode: "+504" },
    { id: 74, name: "Hungary", code: "HU", mobileCode: "+36" },
    { id: 75, name: "Iceland", code: "IS", mobileCode: "+354" },
    { id: 76, name: "India", code: "IN", mobileCode: "+91" },
    { id: 77, name: "Indonesia", code: "ID", mobileCode: "+62" },
    { id: 78, name: "Iran", code: "IR", mobileCode: "+98" },
    { id: 79, name: "Iraq", code: "IQ", mobileCode: "+964" },
    { id: 80, name: "Ireland", code: "IE", mobileCode: "+353" },
    { id: 81, name: "Israel", code: "IL", mobileCode: "+972" },
    { id: 82, name: "Italy", code: "IT", mobileCode: "+39" },
    { id: 83, name: "Jamaica", code: "JM", mobileCode: "+1-876" },
    { id: 84, name: "Japan", code: "JP", mobileCode: "+81" },
    { id: 85, name: "Jordan", code: "JO", mobileCode: "+962" },
    { id: 86, name: "Kazakhstan", code: "KZ", mobileCode: "+7" },
    { id: 87, name: "Kenya", code: "KE", mobileCode: "+254" },
    { id: 88, name: "Kiribati", code: "KI", mobileCode: "+686" },
    { id: 89, name: "Kuwait", code: "KW", mobileCode: "+965" },
    { id: 90, name: "Kyrgyzstan", code: "KG", mobileCode: "+996" },
    { id: 91, name: "Laos", code: "LA", mobileCode: "+856" },
    { id: 92, name: "Latvia", code: "LV", mobileCode: "+371" },
    { id: 93, name: "Lebanon", code: "LB", mobileCode: "+961" },
    { id: 94, name: "Lesotho", code: "LS", mobileCode: "+266" },
    { id: 95, name: "Liberia", code: "LR", mobileCode: "+231" },
    { id: 96, name: "Libya", code: "LY", mobileCode: "+218" },
    { id: 97, name: "Liechtenstein", code: "LI", mobileCode: "+423" },
    { id: 98, name: "Lithuania", code: "LT", mobileCode: "+370" },
    { id: 99, name: "Luxembourg", code: "LU", mobileCode: "+352" },
    { id: 100, name: "Madagascar", code: "MG", mobileCode: "+261" },
    { id: 101, name: "Malawi", code: "MW", mobileCode: "+265" },
    { id: 102, name: "Malaysia", code: "MY", mobileCode: "+60" },
    { id: 103, name: "Maldives", code: "MV", mobileCode: "+960" },
    { id: 104, name: "Mali", code: "ML", mobileCode: "+223" },
    { id: 105, name: "Malta", code: "MT", mobileCode: "+356" },
    { id: 106, name: "Marshall Islands", code: "MH", mobileCode: "+692" },
    { id: 107, name: "Mauritania", code: "MR", mobileCode: "+222" },
    { id: 108, name: "Mauritius", code: "MU", mobileCode: "+230" },
    { id: 109, name: "Mexico", code: "MX", mobileCode: "+52" },
    { id: 110, name: "Micronesia", code: "FM", mobileCode: "+691" },
    { id: 111, name: "Moldova", code: "MD", mobileCode: "+373" },
    { id: 112, name: "Monaco", code: "MC", mobileCode: "+377" },
    { id: 113, name: "Mongolia", code: "MN", mobileCode: "+976" },
    { id: 114, name: "Montenegro", code: "ME", mobileCode: "+382" },
    { id: 115, name: "Morocco", code: "MA", mobileCode: "+212" },
    { id: 116, name: "Mozambique", code: "MZ", mobileCode: "+258" },
    { id: 117, name: "Myanmar", code: "MM", mobileCode: "+95" },
    { id: 118, name: "Namibia", code: "NA", mobileCode: "+264" },
    { id: 119, name: "Nauru", code: "NR", mobileCode: "+674" },
    { id: 120, name: "Nepal", code: "NP", mobileCode: "+977" },
    { id: 121, name: "Netherlands", code: "NL", mobileCode: "+31" },
    { id: 122, name: "New Zealand", code: "NZ", mobileCode: "+64" },
    { id: 123, name: "Nicaragua", code: "NI", mobileCode: "+505" },
    { id: 124, name: "Niger", code: "NE", mobileCode: "+227" },
    { id: 125, name: "Nigeria", code: "NG", mobileCode: "+234" },
    { id: 126, name: "North Korea", code: "KP", mobileCode: "+850" },
    { id: 127, name: "North Macedonia", code: "MK", mobileCode: "+389" },
    { id: 128, name: "Norway", code: "NO", mobileCode: "+47" },
    { id: 129, name: "Oman", code: "OM", mobileCode: "+968" },
    { id: 130, name: "Pakistan", code: "PK", mobileCode: "+92" },
    { id: 131, name: "Palau", code: "PW", mobileCode: "+680" },
    { id: 132, name: "Panama", code: "PA", mobileCode: "+507" },
    { id: 133, name: "Papua New Guinea", code: "PG", mobileCode: "+675" },
    { id: 134, name: "Paraguay", code: "PY", mobileCode: "+595" },
    { id: 135, name: "Peru", code: "PE", mobileCode: "+51" },
    { id: 136, name: "Philippines", code: "PH", mobileCode: "+63" },
    { id: 137, name: "Poland", code: "PL", mobileCode: "+48" },
    { id: 138, name: "Portugal", code: "PT", mobileCode: "+351" },
    { id: 139, name: "Qatar", code: "QA", mobileCode: "+974" },
    { id: 140, name: "Romania", code: "RO", mobileCode: "+40" },
    { id: 141, name: "Russia", code: "RU", mobileCode: "+7" },
    { id: 142, name: "Rwanda", code: "RW", mobileCode: "+250" },
    { id: 143, name: "Saint Kitts and Nevis", code: "KN", mobileCode: "+1-869" },
    { id: 144, name: "Saint Lucia", code: "LC", mobileCode: "+1-758" },
    {
      id: 145,
      name: "Saint Vincent and the Grenadines",
      code: "VC",
      mobileCode: "+1-784",
    },
    { id: 146, name: "Samoa", code: "WS", mobileCode: "+685" },
    { id: 147, name: "San Marino", code: "SM", mobileCode: "+378" },
    { id: 148, name: "Sao Tome and Principe", code: "ST", mobileCode: "+239" },
    { id: 149, name: "Saudi Arabia", code: "SA", mobileCode: "+966" },
    { id: 150, name: "Senegal", code: "SN", mobileCode: "+221" },
    { id: 151, name: "Serbia", code: "RS", mobileCode: "+381" },
    { id: 152, name: "Seychelles", code: "SC", mobileCode: "+248" },
    { id: 153, name: "Sierra Leone", code: "SL", mobileCode: "+232" },
    { id: 154, name: "Singapore", code: "SG", mobileCode: "+65" },
    { id: 155, name: "Slovakia", code: "SK", mobileCode: "+421" },
    { id: 156, name: "Slovenia", code: "SI", mobileCode: "+386" },
    { id: 157, name: "Solomon Islands", code: "SB", mobileCode: "+677" },
    { id: 158, name: "Somalia", code: "SO", mobileCode: "+252" },
    { id: 159, name: "South Africa", code: "ZA", mobileCode: "+27" },
    { id: 160, name: "South Korea", code: "KR", mobileCode: "+82" },
    { id: 161, name: "South Sudan", code: "SS", mobileCode: "+211" },
    { id: 162, name: "Spain", code: "ES", mobileCode: "+34" },
    { id: 163, name: "Sri Lanka", code: "LK", mobileCode: "+94" },
    { id: 164, name: "Sudan", code: "SD", mobileCode: "+249" },
    { id: 165, name: "Suriname", code: "SR", mobileCode: "+597" },
    { id: 166, name: "Sweden", code: "SE", mobileCode: "+46" },
    { id: 167, name: "Switzerland", code: "CH", mobileCode: "+41" },
    { id: 168, name: "Syria", code: "SY", mobileCode: "+963" },
    { id: 169, name: "Tajikistan", code: "TJ", mobileCode: "+992" },
    { id: 170, name: "Tanzania", code: "TZ", mobileCode: "+255" },
    { id: 171, name: "Thailand", code: "TH", mobileCode: "+66" },
    { id: 172, name: "Timor-Leste", code: "TL", mobileCode: "+670" },
    { id: 173, name: "Togo", code: "TG", mobileCode: "+228" },
    { id: 174, name: "Tonga", code: "TO", mobileCode: "+676" },
    { id: 175, name: "Trinidad and Tobago", code: "TT", mobileCode: "+1-868" },
    { id: 176, name: "Tunisia", code: "TN", mobileCode: "+216" },
    { id: 177, name: "Turkey", code: "TR", mobileCode: "+90" },
    { id: 178, name: "Turkmenistan", code: "TM", mobileCode: "+993" },
    { id: 179, name: "Tuvalu", code: "TV", mobileCode: "+688" },
    { id: 180, name: "Uganda", code: "UG", mobileCode: "+256" },
    { id: 181, name: "Ukraine", code: "UA", mobileCode: "+380" },
    { id: 182, name: "United Arab Emirates", code: "AE", mobileCode: "+971" },
    { id: 183, name: "United Kingdom", code: "GB", mobileCode: "+44" },
    { id: 184, name: "United States", code: "US", mobileCode: "+1" },
    { id: 185, name: "Uruguay", code: "UY", mobileCode: "+598" },
    { id: 186, name: "Uzbekistan", code: "UZ", mobileCode: "+998" },
    { id: 187, name: "Vanuatu", code: "VU", mobileCode: "+678" },
    { id: 188, name: "Vatican City", code: "VA", mobileCode: "+379" },
    { id: 189, name: "Venezuela", code: "VE", mobileCode: "+58" },
    { id: 190, name: "Vietnam", code: "VN", mobileCode: "+84" },
    { id: 191, name: "Yemen", code: "YE", mobileCode: "+967" },
    { id: 192, name: "Zambia", code: "ZM", mobileCode: "+260" },
    { id: 193, name: "Zimbabwe", code: "ZW", mobileCode: "+263" },
  ];

  const AllData = [
    {
      id: 1,
      phone_number: +16474772056,
    },
    {
      id: 2,
      phone_number: +16474772056,
    },
    {
      id: 3,
      phone_number: +16474772056,
    },
  ];

const BlockListModal = ({
    showBlockListModal,
    HandleBlockListModalCloseClick,
    activeUserObject
  }) => {
    const [selectedCountryObject, setSelectedCountryObject] = useState({
      id: 32,
      name: "Canada",
      code: "CA",
      mobileCode: "+1",
    });
    const theme = localStorage.getItem("theme");
    const [allFilterCountry, setAllFilterCountry] = useState();
    const [searchCountry, setSearchCountry] = useState("");
    const [selectedCountryCode, setSelectedCountryCode] = useState("+1");
    const [allBlockNumberList, setAllBlockNumberList] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState("");
    const [iconType, setIconType] = useState('success');
    const [isPhoneNumber , setIsPhoneNumber] = useState(null)
    const [phone , setPhone] = useState({
      phone_number:""
    })
    const [phoneNumber, setPhoneNumber] = useState({
      phone_number : ""
    });
  
    const customTextFieldStylesForInvalid = (isInvalid) => {
      return {
        "& .MuiInputLabel-root": {
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "24px",
          letterSpacing: "0.5px",
          color: "rgba(255, 255, 255, 0.80)",
          "&.Mui-focused": {
            color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
          },
        },
        "& .MuiInputBase-input": {
          color: "#FFFFFF",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
          },
          "&:hover fieldset": {
            borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
          },
          "&.Mui-focused fieldset": {
            borderColor: isInvalid
              ? "#F2B8B5 !important"
              : "rgba(255, 255, 255, 0.80) ",
          },
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "rgba(255, 255, 255, 0.40)",
        },
      };
    };
  
    const handleSearch = (e) => {
      e.stopPropagation();
      const value = e.target.value.toLowerCase();
      setSearchCountry(value);
      const filtered = countryDatas.filter((country) =>
        country.name.toLowerCase().includes(value)
      );
      setAllFilterCountry(filtered);
    };
  
    const handleCountryCodeChange = (country) => {
      // const CountryObject = event.target.value;
      // console.log("CountryObject", country)
      setSelectedCountryObject(country);
      setSelectedCountryCode(country.mobileCode);
    };
  
    const getBlockNumberList = async () =>{
      try{
        const jsonResponse = await getBlockNumberDataForCallingAgent (activeUserObject?.id, currentPage)
        const response = await jsonResponse.json()
        if(response?.status){
          setAllBlockNumberList(response?.data?.data)
          }else{
            setOpen(true);
            setContent(response?.message);
            setIconType('error');
          }
      }catch(error){
        console.log(error)
        setOpen(true);
        setContent(error?.message);
        setIconType('error');
      }
    }

    const handleAddBlockListButtonClick = async () =>{
      try{
      const jsonResponse = await  AddNumberInBlockListForCallingAgent(activeUserObject?.id, phone );
      const Response = await jsonResponse.json();
      if(Response?.status){
         setOpen(true)
         setContent(Response?.message)
         setIconType('success')
         getBlockNumberList()
         setPhone({phone_number:""})
         setPhoneNumber({phone_number:""})
      }else{
        setOpen(true);
        setContent(Response?.message);
        setIconType('error');
      }
      }catch(error){
        console.log(error)
        setOpen(true);
        setContent(error?.message);
        setIconType('error');
      }
    }
  
    useEffect(()=>{
        getBlockNumberList()
    },[])
  
    const handleToastClose = () =>{
      setOpen(false)
  }

  const handleNumberChange = (event) => {
    //write code for number
    setIsPhoneNumber(null)
    let value = event.target.value;
    setPhoneNumber(value)
    setPhone({
      phone_number:`${selectedCountryObject?.mobileCode}${value}`
    });
  }

  const handleDeleteButtonClick =async (row) => {
    // console.log("deleteData", row)
    try{
      const response = await DeleteNumberInBlockListbyIdForCallingAgent(activeUserObject.id, row.id)
      const res = await response.json()
      if(res?.status){
        setOpen(true)
        setContent(res?.message)
        setIconType('success')
        getBlockNumberList()
     }else{
       setOpen(true);
       setContent(res?.message);
       setIconType('error');
     }
    }catch(error){
      console.log(error)
      setOpen(true);
      setContent(error?.message);
      setIconType('error');
    }
  }
  
    return (
      <div>
        <Modal
          open={showBlockListModal}
          onClose={HandleBlockListModalCloseClick}
          aria-labelledby="audio-settings-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "480px",
              backgroundColor: "background.paper",
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
              bgcolor: theme === "dark" ? settingsModal_bg_color_dm : "",
              borderRadius: "8px",
            }}
          >
            <Box sx={{display:"flex", flexDirection:"column"}}>
            <Typography
              id="audio-settings-title"
              variant="h6"
              component="h2"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "68px",
                // mb: 2,
                borderBottom: `1px solid ${
                  theme === "dark" ? "rgba(255, 255, 255, 0.20)" : ""
                }`,
                padding: "20px",
                font: "Inter",
              }}
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: theme === "dark" ? "#FFFFFF" : "",
              }}
            >
              Blocked numbers
              <IconButton
                aria-label="close"
                onClick={HandleBlockListModalCloseClick}
                sx={{
                  // color: (theme) => theme.palette.grey[500],
                  color: "#FFFFFF",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Typography>
            <Box sx={{ padding: "0px" }}>
              <Box sx={{ border: "", borderRadius: "8px", padding: "20px" }}>
                <TableContainer>
                  <Table
                    sx={{
                      fontFamily: "Inter",
                      color: "#ffffff",
                      padding: "20px 24px",
                      borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          S. No.
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          Phone number
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allBlockNumberList?.map((row, index) => {
                        return (
                          <TableRow
                            key={row.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell
                              align="left"
                              sx={{
                                fontFamily: "Inter",
                                color: "#ffffff",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "28px",
                                padding: "20px 24px",
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.10)",
                              }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                fontFamily: "Inter",
                                color: "#ffffff",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "28px",
                                padding: "20px 24px",
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.10)",
                              }}
                            >
                              {row.phone_number}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                fontFamily: "Inter",
                                color: "#ffffff",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "28px",
                                padding: "20px 24px",
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.10)",
                              }}
                            >
                              <Box>
                                <Button
                                  onClick={()=>handleDeleteButtonClick(row)}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    borderRadius: "50%",
                                    alignItems: "center",
                                    maxWidth: "36px",
                                    minWidth: "36px",
                                    height: "36px",
                                    bgcolor: "#1F233E",
                                    padding: "8px",
                                  }}
                                >
                                  <DeleteIcon 
                                    sx={{
                                      color: "#CAC4D0",
                                      width: "20px",
                                      height: "20px",
                                      bgcolor: "#1F233E",
                                    }}
                                  />
                                </Button>
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            </Box>
            <Typography
              id="audio-settings-title"
              variant="h6"
              component="h2"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "68px",
                padding: "20px",
                font: "Inter",
              }}
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: theme === "dark" ? "#FFFFFF" : "",
              }}
            >
              Add number to blocklist
            </Typography>
            <Box
              sx={{
                margin: "0px 20px 20px 20px",
                display: "flex",
                flexDirection: "row",
                columnGap: "20px",
              }}
            >
              <TextField
                type="tel"
                onChange={handleNumberChange}
                value={phoneNumber.phone_number}
                label="Phone number*"
                variant="outlined"
                sx={() => customTextFieldStylesForInvalid(false)}
                placeholder="Phone number*"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" sx={{ padding: "0px" }}>
                      <Select
                        // onChange={()=>{setSelectedCountryObject(country)}}
                        select
                        value={selectedCountryObject?.id || ""}
                        // onChange={(e)=>handleCountryCodeChange(e)}
                        variant="standard"
                        style={{ width: "80px", height: "40px", padding: "0px" }} // Adjust width to accommodate flags
                        renderValue={(selectedId) => {
                          const country = countryDatas.find(
                            (c) => c.id === selectedId
                          );
                          return (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                columnGap: "10px",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              {/* <img 
                                    src={country.flag} 
                                    alt="flag" 
                                    style={{ width: '24px', height: '24px' }} 
                                  /> */}
                              <GetCountryFlagByName countryName={country?.name} />
                              <p
                                style={{
                                  margin: "0px",
                                  color: "rgba(255, 255, 255, 0.80)",
                                }}
                              >
                                {country?.mobileCode}
                              </p>
                            </Box>
                          );
                        }}
                        sx={{
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "&:hover:not(.Mui-disabled):before": {
                            border: "none",
                          },
                          "&::before": {
                            borderBottom: "none",
                          },
                          "&::after": {
                            borderBottom: "none",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              backgroundColor: "#282D51",
                              color: "white",
                              // Add other custom styles here
                            },
                          },
                        }}
                        SelectProps={{ 
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                bgcolor: "#282D51",
                                padding: "0px",
                                "& .MuiMenuItem-root.Mui-selected": {
                                  bgcolor: "#282D51",
                                  color: "white",
                                  // width:"200px",
                                  "&:hover": {
                                    bgcolor: "#393F69",
                                  },
                                },
                              },
                            },
                            onClose: (event) => {
                              // Prevent closing if the user clicked inside the search input
                              if (event?.target?.id === "search-country-input") {
                                event.stopPropagation();
                              }
                            },
                          },
                        }}
                      >
                        <Box
                          sx={{
                            border: "",
                            height: "180px",
                            width: "220px",
                            overflowX: "hidden",
                            overflowY: "scroll",
                            color: "#282D51",
                            bgcolor: "#282D51",
                            padding: "0px",
                          }}
                        >
                          {/* {countryCodes.map((country) => ( */}
                          <Box
                            sx={{
                              p: 1,
                              borderBottom: "1px solid rgba(255,255,255,0.1)",
                            }}
                          >
                            <Input
                              // value={searchCountry}
                              // onChange={handleSearch}
                              placeholder="Search country"
                              onMouseDown={(e) => e.stopPropagation()}
                              onClick={(e) => e.stopPropagation()}
                              startAdornment={
                                <InputAdornment position="start">
                                  <SearchIcon
                                    sx={{ color: "rgba(255,255,255,0.7)" }}
                                  />
                                </InputAdornment>
                              }
                              sx={{
                                color: "white",
                                "&:before, &:after": { borderBottom: "none" },
                                "&:hover:not(.Mui-disabled):before": {
                                  borderBottom: "none",
                                },
                              }}
                              disableUnderline={false}
                            />
                          </Box>
                          {allFilterCountry?.map((country) => (
                            <MenuItem
                              onClick={() => handleCountryCodeChange(country)}
                              key={country?.id}
                              value={country}
                              sx={{
                                bgcolor:
                                  country?.id == selectedCountryObject?.id
                                    ? "#373E6D"
                                    : "#282D51",
                                // marginTop : '-8px',
                                // marginBottom : '-8px',
                                width: "220px",
                                height: "48px",
                                alignItems: "center",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  backgroundColor: "#373E6D !important",
                                  color: "white",
                                },
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "24px",
                                    height: "21px",
                                    // marginRight : '12px',
                                    columnGap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  {/* <CardMedia value={country.flag} 
                                    component="img" // Can also be "video" or other media types        
                                    image={country.flag} // Replace with your image URL
                                    alt="flag"
                                  /> */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      height: "21px",
                                      alignItems: "center",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    <GetCountryFlagByName
                                      countryName={country?.name}
                                    />
                                  </Box>
                                  <Typography
                                    sx={{
                                      display: "flex",
                                      color: "white",
                                      fontFamily: "Inter",
                                      fontSize: "14px",
                                      textAlign: "left",
                                      opacity: "80%",
                                      height: "21px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {country.name}{" "}
                                  </Typography>
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "white",
                                      fontFamily: "Inter",
                                      fontSize: "14px",
                                      textAlign: "left",
                                      opacity: "80%",
                                      marginLeft: "5px",
                                      height: "21px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {country.mobileCode}
                                  </Typography>
                                </Box>
                              </Box>
                            </MenuItem>
                          ))}
                        </Box>
                      </Select>
                    </InputAdornment>
                  ),
                }}
                style={{
                  width: "100%",
                  maxWidth: "340px",
                  height: "56px",
                  color: "#FFFFFF",
                  backgroundColor: "#232746",
                  borderRadius: "8px",
                  boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                  placeholderfontsize: "16px",
                  // marginBottom : '20px'
                }}
              />
  
              <Button
                variant="contained"
                onClick={() => handleAddBlockListButtonClick()}
                sx={{
                  backgroundColor:
                    theme === "dark" ? button_bg_color_for_New_Project : "",
                  "&:hover": {
                    backgroundColor: "#FFD9AA",
                  },
                  color: "#17182C",
                  fontSize: "16px",
                  fontWeight: 600,
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  minWidth: "132px",
                }}
              >
                Block number
              </Button>
            </Box>
          </Box>
        </Modal>
        <CommonToast  open={open} onClose={handleToastClose} content={content} iconType={iconType} bgColor={"#282D51"}/>
      </div>
    );
  };

  export default BlockListModal;